import styles from "./MaterialPreview.module.scss";
import { useStandaloneContent } from "@src/hooks/useStandaloneContent";
import SelectedContent from "@src/components/lesson-details/selected-content/SelectedContent";
import { useEffect } from "react";
import { Events, useAnalytics, useUser } from "@src/hooks";
import { resolveMixpanelStandaloneGrade } from "@src/utils/mixpanelProgramType";

type Props = {
  onClose: () => void;
  needPrint?: boolean;
  onShare?: () => void;
};

function SllMaterialPreview(props: Props) {
  const { onClose, needPrint, onShare } = props;

  const { content: selectedContent, lesson } = useStandaloneContent();

  const { trackEvent } = useAnalytics();
  const [user] = useUser();

  useEffect(() => {
    if (selectedContent && user) {
      trackEvent(Events.actions.lessonMaterials, {
        module_name: selectedContent.name,
        lesson_name: lesson?.name || "",
        grade: resolveMixpanelStandaloneGrade({
          ageGroup: lesson?.ageGroup,
          gradeLevel: lesson?.gradeLevel,
        }),
        schoolId: user?.schools?.[0]?.id,
        schoolName: user?.schools?.[0]?.name,
        userId: user?.id,
        userName: `${user?.firstName} ${user?.lastName}`,
      });
    }
  }, [selectedContent, user, lesson, trackEvent]);

  return (
    <div className={styles.container}>
      <div className={styles.page}>
        {selectedContent && (
          <SelectedContent
            content={selectedContent}
            goBack={onClose}
            isMaterial={true}
            needPrint={needPrint}
            onShare={onShare}
          />
        )}
      </div>
    </div>
  );
}

export default SllMaterialPreview;
